import Dialog from 'global/guides/Dialog'
import { useAuth } from 'hooks'
import { avaliacao, CreateAvaliacaoSchema } from 'service/api'
import { toast } from 'sonner'
import { FormAvaliacao } from './atoms/forms'

export function FormularioAvaliacao() {
    const { handleLogin } = useAuth()

    const { mutateAsync, isLoading } = avaliacao.mutations.useCreate({
        onSuccess: async data => {
            toast.success(`Avaliação criada com sucesso!`)
            handleLogin(data.Token!)
        },
        onError: err => {
            toast.error(err.message)
        },
    })

    return (
        <Dialog.Root
            loading={isLoading}
            onSubmit={values => mutateAsync(values)}
            schema={CreateAvaliacaoSchema}
            width="38rem"
        >
            <Dialog.Title>Vamos começar</Dialog.Title>
            <Dialog.Content dividers>
                <span className="mb-8 text-md text-center select-none">
                    Cadastre-se e ganhe 14 dias grátis!
                </span>
                <FormAvaliacao />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton>
                    Cadastrar
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
